module.exports = __webpack_public_path__ + "img/counter_l_ledge.08d14a6f.png";